import { type ReactElement } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import type { TooltipProps as MuiTooltipProps } from '@mui/material/Tooltip';
import theme from 'shared/themes/default';
import TooltipDesktop from './components/TooltipDesktop';
import TooltipMobile from './components/TooltipMobile';

interface TooltipProps {
  arrow?: boolean;
  children: ReactElement;
  maxWidth?: string;
  placement?: MuiTooltipProps['placement'];
  title?: string | ReactElement;
}

const Tooltip = (props: TooltipProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.mobile);
  if (!isMobile) {
    return <TooltipDesktop {...props} />;
  }
  return <TooltipMobile {...props} />;
};

export default Tooltip;

export type { TooltipProps };
